import Cookies from "js-cookie";
import { useRouter } from "next/router";
import { useMemo, useState, useEffect } from "react";

const useFilter = (data, parpageElement) => {
  const [pending, setPending] = useState([]);
  const [onhold, setOnhold] = useState([]);
  const [processing, setProcessing] = useState([]);
  const [packing, setPacking] = useState([]);
  const [delayeddelivery, setDelayedDelivery] = useState([]);
  const [confirmedforbooking, setConfirmedforBooking] = useState([]);
  const [booked, setBooked] = useState([]);
  const [handedovertocourier, setHandedovertoCourier] = useState([]);
  const [delivered, setDelivered] = useState([]);
  const [sortedField, setSortedField] = useState("");
  const [resultsPerPage, setResultPerPage] = useState(parpageElement || 12);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataTable, setDataTable] = useState([]);
  const [flagForPrice, setFlagForPrice] = useState(false);
  const router = useRouter();

  const productData = useMemo(() => {
    let services = data;
    //filter user order
    if (router.pathname === "/user/dashboard") {
  if (Cookies.get("userInfo")) {
    if (Array.isArray(services)) {
      const orderPending = services.filter(
        (statusP) => statusP.status === "Pending"
      );
      setPending(orderPending);
    



        const orderOnhold = services.filter(
          (statusO) => statusO.status === "On-hold"
        );
        setOnhold(orderOnhold);

        const orderProcessing = services.filter(
          (statusO) => statusO.status === "Processing"
        );
        setProcessing(orderProcessing);

        const orderPacking = services.filter(
          (statusO) => statusO.status === "Packing"
        );
        setPacking(orderPacking);

        const orderDelayedDelivery = services.filter(
          (statusO) => statusO.status === "Delayed Delivery"
        );
        setDelayedDelivery(orderDelayedDelivery);


        const orderConfirmedforBooking = services.filter(
          (statusO) => statusO.status === "Confirmed for Booking"
        );
        setConfirmedforBooking(orderConfirmedforBooking);


        const orderBooked = services.filter(
          (statusO) => statusO.status === "Booked"
        );
        setBooked(orderBooked);

        const orderHandedovertoCourier = services.filter(
          (statusO) => statusO.status === "Handed over to Courier"
        );
        setHandedovertoCourier(orderHandedovertoCourier);


        const orderDelivered = services.filter(
          (statusD) => statusD.status === "Delivered"
        );
        setDelivered(orderDelivered);
      }
    }
    }

    //service sorting
    if (sortedField === "Default") {
      setFlagForPrice(!flagForPrice);
      services = data.sort((a, b) => a.createdAt < b.createdAt && -1);
    } else if (sortedField === "New_Release") {
      setFlagForPrice(!flagForPrice);
      services = data.sort((a, b) => a.createdAt > b.createdAt && -1);
    } else if (sortedField === "Low") {
      setFlagForPrice(!flagForPrice);
      services = data.sort((a, b) => a.price < b.price && -1);
    } else if (sortedField === "High") {
      setFlagForPrice(!flagForPrice);
      services = data.sort((a, b) => a.price > b.price && -1);
    } else if (sortedField === "Review") {
      setFlagForPrice(!flagForPrice);
      services = data.sort((a, b) => a.avgRating > b.avgRating && -1);
    } else if (sortedField === "totalSalesCount") {
      setFlagForPrice(!flagForPrice);
      services = data.sort(
        (a, b) => a.totalSalesCount > b.totalSalesCount && -1
      );
    } else if (sortedField === "Availability") {
      setFlagForPrice(!flagForPrice);
      services = data.sort((a) => a.quantity > 0 && -1);
    }

    return services;

    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [sortedField, data]);

  useEffect(() => {
    if (Array.isArray(data)) {
    setDataTable(
      data.slice(
        (currentPage - 1) * resultsPerPage,
        currentPage * resultsPerPage
      )
    );}
  }, [data, currentPage, resultsPerPage, flagForPrice]);

  const handleChangePage = (p) => {
    setCurrentPage(p);
  };
  //pull

  return {
    productData,
    pending,
    onhold,
    processing,
    packing,
    delayeddelivery,
    confirmedforbooking,
    booked,
    handedovertocourier,
    delivered,
    sortedField,
    setSortedField,
    handleChangePage,
    dataTable,
    resultsPerPage,
    setResultPerPage,
  };
};

export default useFilter;
